module.exports = __webpack_public_path__ + "5a4f7daf0b57862e443d464974f76ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/recommendation.jpg
// module id = 187
// module chunks = 0